import type { Template } from "@/types";

export const LA_05_H4_V1: Template[] = [
    {
        id: "la-05-h4v1-01",
        name: "LA 01 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_01.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 67, y: 82, width: 542, height: 379, rotation: 0, imageRotation: 0 },
            { id: "2", x: 796, y: 81, width: 171, height: 121, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 211, width: 171, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 339, width: 171, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 975, y: 81, width: 258, height: 379, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-02",
        name: "LA 02 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_02.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 65, y: 67, width: 269, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 280, width: 269, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 67, width: 269, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 280, width: 269, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 67, width: 286, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-03",
        name: "LA 03 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_03.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 123, y: 85, width: 258, height: 182, rotation: 0, imageRotation: 0 },
            { id: "2", x: 123, y: 275, width: 258, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 478, y: 0, width: 396, height: 541, rotation: 0, imageRotation: 0 },
            { id: "4", x: 971, y: 85, width: 258, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 971, y: 275, width: 258, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-04",
        name: "LA 04 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_04.png",
        size: [1352, 541],
        style: {},
        slots: [           
            { id: "1", x: 0, y: 180, width: 236, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 180, width: 236, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 488, y: 0, width: 376, height: 541, rotation: 0, imageRotation: 0 },
            { id: "4", x: 872, y: 180, width: 236, height: 181, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1116, y: 180, width: 236, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-05",
        name: "LA 05 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_05.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 237, y: 45, width: 204, height: 144, rotation: 0, imageRotation: 0 },
            { id: "2", x: 237, y: 351, width: 204, height: 144, rotation: 0, imageRotation: 0 },
            { id: "3", x: 873, y: 45, width: 282, height: 450, rotation: 0, imageRotation: 0 },
            { id: "4", x: 131, y: 198, width: 205, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 344, y: 198, width: 204, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-06",
        name: "LA 06 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_06.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 109, y: 53, width: 457, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 109, y: 388, width: 147, height: 103, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 388, width: 147, height: 103, rotation: 0, imageRotation: 0 },
            { id: "4", x: 419, y: 388, width: 147, height: 103, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 53, width: 304, height: 438, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-07",
        name: "LA 07 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_07.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 201, y: 38, width: 301, height: 230, rotation: 0, imageRotation: 0 },
            { id: "2", x: 201, y: 276, width: 301, height: 228, rotation: 0, imageRotation: 0 },
            { id: "3", x: 510, y: 38, width: 332, height: 466, rotation: 0, imageRotation: 0 },
            { id: "4", x: 850, y: 38, width: 301, height: 230, rotation: 0, imageRotation: 0 },
            { id: "5", x: 850, y: 276, width: 301, height: 228, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-08",
        name: "LA 08 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_08.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 46, y: 56, width: 581, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 635, y: 56, width: 401, height: 275, rotation: 0, imageRotation: 0 },       
            { id: "3", x: 635, y: 339, width: 197, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 840, y: 339, width: 196, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1044, y: 56, width: 264, height: 429, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-09",
        name: "LA 09 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_09.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 46, y: 56, width: 400, height: 275, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 339, width: 196, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 339, width: 196, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 454, y: 56, width: 580, height: 429, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 56, width: 264, height: 429, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-10",
        name: "LA 10 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_10.png",
        size: [1352, 541],
        style: {},
        slots: [
            { id: "1", x: 46, y: 56, width: 264, height: 429, rotation: 0, imageRotation: 0 },
            { id: "2", x: 318, y: 56, width: 580, height: 429, rotation: 0, imageRotation: 0 },
            { id: "3", x: 906, y: 212, width: 400, height: 273, rotation: 0, imageRotation: 0 },
            { id: "4", x: 906, y: 56, width: 196, height: 147, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 56, width: 196, height: 147, rotation: 0, imageRotation: 0 }
        ],
    }
];